import ShopaholicProductList from "@oc-shopaholic/shopaholic-product-list/shopaholic-product-list";
import ShopaholicPagination from "@oc-shopaholic/shopaholic-product-list/shopaholic-pagination";
import ShopaholicSorting from "@oc-shopaholic/shopaholic-product-list/shopaholic-sorting";

const obListHelper = new ShopaholicProductList();
obListHelper.setAjaxRequestCallback((obRequestData) => {
    obRequestData.update = { 'catalog/catalog-content-ajax': `.products__wrapper` };
    obRequestData.loading = oc.progressBar.show();
    obRequestData.complete = () => {
        window.scrollTo({
            top: 280,
            behavior: 'smooth'
        });
        oc.progressBar.hide();
    };

    return obRequestData;
});

// pagination
const obPaginationHelper = new ShopaholicPagination(obListHelper);
obPaginationHelper.init();

// sorting
const obSortingHelper = new ShopaholicSorting(obListHelper);
obSortingHelper.init();
